import initActivoPageViewChart from "../../common/functions/initActivoPageViewChart";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.static_pages.about.pc").length) return;
  initActivoPageViewChart(false); // 右軸なし
});
